import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TwoLineItemComponent } from './two-line-item.component';

@NgModule({
  declarations: [
    TwoLineItemComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TwoLineItemComponent
  ]
})
export class TwoLineItemModule { }
